import moment from 'moment'
export default {
  props: ['value'],
  data() {
    return {
      show: false,
      icebreaker: this.value,
      showAdvanced: false,
      timestamp: moment().format('x')
    }
  },
  mounted() {
    if (!this.icebreaker) {
      this.icebreaker = {
        question: null,
        payload: null
      }
    }

    this.cached_icebreaker = JSON.stringify(this.icebreaker)
  },
  methods: {
    onCancel() {
      this.icebreaker = JSON.parse(this.cached_icebreaker)
      this.$emit('onSave', {
        icebreaker: this.icebreaker,
        onClear: function () {
          // vm.icebreaker = {
          //   question: null,
          //   payload: null
          // }
          vm.cached_icebreaker = JSON.stringify(vm.icebreaker)
        }
      })
      this.show = false
      this.timestamp = moment().format('x')
    },
    onSave() {
      var vm = this
      this.$emit('onSave', {
        icebreaker: this.icebreaker,
        onClear: function () {
          vm.icebreaker = {
            question: null,
            payload: null
          }
          vm.cached_icebreaker = JSON.stringify(vm.icebreaker)
        }
      })
      vm.cached_icebreaker = JSON.stringify(vm.icebreaker)
      this.show = false
      this.timestamp = moment().format('x')
    },
    onChange: function () {
      this.icebreaker.payload = this.icebreaker.question
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/welcomemessage/ManageIceBreaker.js